import {Component, Input, OnInit} from '@angular/core';

/**
 * A component that renders an SVG of the full Gallix Logo
 */
@Component({
    selector: 'app-logo-full',
    templateUrl: './logo-full.component.html',
    styleUrls: ['./logo-full.component.scss'],
    standalone: false
})
export class LogoFullComponent implements OnInit {
  @Input() contrast = false;
  mainColour: string;

  ngOnInit(): void {
    this.mainColour = this.contrast ? 'var(--gallix-color-white-contrast)' : 'var(--global-const-white)';
  }
}
